import Vue from "vue";
import ElementUI from "element-ui";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./permission"; // permission control
import "./assets/styles/index.scss";
import "@/assets/styles/iconfont.css";
import "@/assets/styles/element-variables.scss";
// 引入字体图标库
import "element-ui/lib/theme-chalk/icon.css";
import axios from "./utils/request";
// import '@/assets/js/iconfont.js'
import "font-awesome/css/font-awesome.min.css";
import "./icons";
import site from "./config/site.json";
// import ZhilinCMS from "zhilin-cms";
// Vue.use(window['vue-cropper'])
import VueCropper from "vue-cropper";
import "./utils/theme-setting";

Vue.prototype.$http = axios;

Vue.prototype.imgError = function (e) {
  e.target.src = "/static/img/pic-default.png";
};

Vue.config.productionTip = false;
// Vue.use(ZhilinCMS);
Vue.use(VueCropper);
Vue.use(ElementUI);
Vue.prototype.$site = site;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
